import AppDashboard from "../../app/layout/AppDashboard";
import Dashboard from "./views/Dashboard";
import Auth from "../auth/middleware/Auth";
import Admin from "../auth/middleware/Auth";
import JobDescription from "./components/JobDescription";

export default [
  {
    path: "/dashboard",
    component: AppDashboard,
    children: [
      {
        path: "",
        redirect: "/dashboard/main",
      },
      {
        path: "main",
        components: {
          view: Dashboard,
        },
        meta: {
          middleware: Auth,
          breadcrumb: [
            { text: "Dashboard", disabled: false, href: "/dashboard/main" },
          ],
        },
      },
      {
        path: "job-description:position",
        name: "JobDescription",
        components: {
          view: JobDescription,
        },
      },
    ],
  },
];
